module.exports = __webpack_public_path__ + "assets/img/18.8af8c209.png";